import axios from 'axios'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'
import { useToast } from '@percent/admin-dashboard/containers/toast/ToastContext'
import { ConfirmationModal, Modal } from '@percent/lemonade'
import { APIErrorHandler, useMutation } from '@percent/utility'
import { DuplicateModalProps } from './modals.types'

export function DuplicateModal({ program, isModalOpen, setIsModalOpen }: DuplicateModalProps) {
  const { t } = useTranslation()
  const toast = useToast()
  const navigate = useNavigate()
  const { validationSubmissionsService } = useServices()

  const [{ isPending }, { apiFunc: duplicateValidationSubmission }] = useMutation(
    validationSubmissionsService.duplicateValidationSubmission,
    response => {
      navigate(`/partners/${program.partnerId}/programs/${response.data.id}/duplicate-program`)
    },
    error => {
      if (axios.isAxiosError(error)) {
        toast(APIErrorHandler(error?.response?.data?.error), 'error')
      }
    }
  )

  const handleSubmit = () => duplicateValidationSubmission({ configurationId: program.id })
  const handleClose = () => setIsModalOpen(false)

  return (
    <Modal open={isModalOpen}>
      <ConfirmationModal
        title={t('confirmationModal.duplicateProgram.title')}
        primaryButtonText={t('button.duplicateProgram')}
        primaryBtnTestId="duplicate-program"
        secondaryButtonText={t('button.cancel')}
        loading={isPending}
        handleSubmit={handleSubmit}
        handleClose={handleClose}
      >
        {t('confirmationModal.duplicateProgram.description', {
          programName: program.name || t('typography.unnamedProgram')
        })}
      </ConfirmationModal>
    </Modal>
  )
}
